import React from 'react';
import { useState } from "react";
import { useMatch, useNavigate } from "react-router-dom";
import SchedulerEditorPage from './SchedulerEditor.page';
import MeetingsPage from './Meetings.page';
export const SchedulingConfig = ({ integration }) => {
    const navigate = useNavigate();
    const [activePath, setActivePath] = useState('/integrations/scheduling');
    const items = [
        { label: 'Scheduling', path: '/integrations/scheduling' },
        { label: 'Calendar', path: '/integrations/scheduling/calendar' },
    ];
    return (React.createElement("div", { className: "space-y-4" },
        React.createElement("div", { className: "flex items-center gap-6 border-b border-gray-200 pb-2" }, items.map(item => {
            const isActive = useMatch(item.path) !== null;
            return (React.createElement("button", { key: item.path, onClick: () => {
                    setActivePath(item.path);
                    navigate(item.path, { replace: true });
                }, className: `pb-2 text-sm font-medium border-b-2 transition-colors ` +
                    (isActive
                        ? 'text-gray-900 border-orange-500'
                        : 'text-gray-500 hover:text-gray-700 border-transparent') }, item.label));
        })),
        React.createElement("div", { className: "mt-2" },
            activePath === '/integrations/scheduling' && React.createElement(SchedulerEditorPage, { integration: integration }),
            activePath === '/integrations/scheduling/calendar' && React.createElement(MeetingsPage, null))));
};
